'use client';
import cn from 'classnames';
import { ReactNode } from 'react';
import Slider, { Settings } from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import './PostListSlider.scss';
import { useBreakpoints } from '@hooks/useBreakpoints';
interface PostListSliderProps {
  className?: string;
  children: ReactNode;
}
export default function PostListSlider({
  className,
  children,
}: PostListSliderProps) {
  const { isBreakpointUp } = useBreakpoints();
  const settings: Settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: isBreakpointUp('lg'),
    draggable: true,
  };

  return (
    <Slider className={cn('post-list-slider', className)} {...settings}>
      {children}
    </Slider>
  );
}
